var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "            <li data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-cid=\""
    + alias2(alias1((depth0 != null ? depth0.cid : depth0), depth0))
    + "\">\n                <span class=\"status\"></span>\n                <span class=\"name\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.menuItem : depth0)) != null ? stack1.name : stack1), depth0))
    + "</span>\n                <span class=\"quantity\">x "
    + alias2(alias1((depth0 != null ? depth0.orderedQuantity : depth0), depth0))
    + "</span>\n            </li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"modal-body billItemsList\">\n    <div class=\"all-choose\">\n        <span class=\"status\"></span>\n        <span class=\"name\">全选</span>\n    </div>\n    <ul class=\"row billItemsListSelectList\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.billItemJson : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </ul>\n    <button class=\"confirm-switch\">转菜</button>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/pos/comp/BillItemSelectList.handlebars
// module id = 559
// module chunks = 0